import { useLayoutEffect, useRef, useState } from "react";

export default function useResizeObserver(elementRef) {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const roRef = useRef(null);

  console.log("[OBSERVE] Use resize observer", elementRef);

  useLayoutEffect(() => {
    console.log("[OBSERVE] Init", elementRef);
    if (typeof window === "undefined" || !window.ResizeObserver) {
      console.log("[OBSERVE] ResizeObserver not supported");
      return;
    }

    const node = elementRef?.current;
    if (!node) {
      console.log("[OBSERVE] Node not found");
      return;
    }

    // Create observer once per effect run; disconnect on cleanup.
    const ro = new window.ResizeObserver((entries) => {
      const entry = entries[0];
      console.log("[OBSERVE] Entry is", entry);
      if (!entry) {
        return;
      }

      // Avoid RO loop warnings by scheduling state update.
      window.requestAnimationFrame(() => {
        console.log("[OBSERVE] Got animation frame", entry.contentRect);
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      });
    });

    ro.observe(node);
    roRef.current = ro;

    return () => {
      ro.unobserve(node);
      ro.disconnect();
      if (roRef.current === ro) roRef.current = null;
    };
  }, [elementRef.current]); // note: this won't react to ref.current changes without rerender

  return size;
}
